export default __webpack_public_path__ + "static/media/diamond-package.8b7f5060.png";